import React from "react";
import { Comment, Image } from "semantic-ui-react";
import moment from "moment";

const isOwnMessage = (author, user) => {
    return author.uid === user.uid ? "message__self" : "";
};

const timeFromNow = timestamp => moment(timestamp).fromNow();

const Message = ({ message, user }) => (
    <Comment size="tiny" >
 
        {/* {console.log(message)} */}
        {/* {console.log(user)} */}
        <Comment.Avatar src={message.author.avatar} />
        <Comment.Content id={isOwnMessage(message.author, user)}>
            <Comment.Author
                as="a"
                style={{ color: "black", fontSize: "1.2em" }}
            >
                {message.author.username}
            </Comment.Author>
            <Comment.Metadata style={{ color: "black" }}> 
                ~{timeFromNow(message.timestamp)}
            </Comment.Metadata>
            <Comment.Text style={{ color: "black" }}>
                {message.text}
            </Comment.Text>
            {message.imageURL && (
                <Image src={message.imageURL} className="message__image" />
            )}
            {message.fileURL && (
                <a
                    href={message.fileURL}
                    target="_blank"
                    style={{ color: "lightskyblue" }}
                >
                    {message.fileName}
                </a>
            )}
        </Comment.Content>
    </Comment>
);

export default Message;


// user
//   style={{ color: "lightcyan", fontSize: "1.2em" }}

//message header
// style={{ color: "silver" }}> 

//message texts
// style={{ color: "gainsboro" }}>

//add members
//  style={{ color: "lightskyblue" }}
